import { createSlice } from "@reduxjs/toolkit";

const initialState = { ATRC: {}, DashSelection: {}, DashboardType: false };

export const commonSlice = createSlice({
  name: "common",
  initialState,
  reducers: {
    AttendeeRegistrationConference(state, action) {
      state.ATRC = action.payload;
    },
    AcademicYearandSchoolDistrictSelection(state, action) {
      state.DashSelection = action.payload;
    },
    DefaultDashboardType(state, action) {
      state.DashboardType = action.payload;
    },
    resetCommon: () => initialState,
  },
});

export const {
  AttendeeRegistrationConference,
  AcademicYearandSchoolDistrictSelection,
  DefaultDashboardType,
  resetCommon,
} = commonSlice.actions;

export default commonSlice.reducer;
